import { render } from "./dol-import.vue?vue&type=template&id=06b6fad7"
import script from "./dol-import.vue?vue&type=script&lang=js"
export * from "./dol-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__